module.exports = __webpack_public_path__ + "media/images/emblems/Orselina-coat_of_arms-1ca031d7d4fcb0cdacf6658b71e45946.svg";